/**
 * sdx-gwp.js — Hediye kampanyası (Gift With Purchase).
 *
 * Görev 1 (uzlaştırıcı): Sepet her değiştiğinde tutarı ölç.
 *   >= eşik  -> hediyeyi sepete ekle (tam 1 adet)
 *   <  eşik  -> hediye satırını SİL
 * Görev 2 (pop-up): Teşvik bandına (eşik altı ama alt sınır üstü) girince bir kez bildir;
 *   hediye kazanılınca onay göster.
 *
 * Ayarların tamamı `gwp_config` metaobject'inden gelir (bkz. snippets/sdx-gwp-config.liquid).
 * Bu dosyada eşik/metin HARDCODE EDİLMEZ.
 *
 * ÜCRETSİZLİK NEREDEN GELİYOR: hediyenin fiyatı GERÇEKTEN 0'dır — indirimle
 * sıfırlanmış değil. Neden (ölçüldü 2026-09-23): bu planda sepet başına BİR sipariş +
 * BİR ürün indirimi uygulanıyor. Hediye indirimle ücretsizleştirilseydi bir ÜRÜN
 * indirimi olur ve Kaching çoklu alım / "Birlikte daha iyi" ile aynı yuva için
 * yarışırdı — ölçüldü, her iki sepette de hediye ücretli kaldı. Fiyat 0 olunca
 * hiçbir yuva harcanmaz, hediye her sepette çalışır.
 * Ölçülen tutar = cart.total_price eksi hediye satırının kendi tutarı (ERP kısıtı
 * nedeniyle 0,01 TL; bu yüzden çıkarma gerçekten gerekli).
 */
(function () {
  'use strict';

  var CFG = null;
  try {
    var node = document.getElementById('sdx-gwp-config');
    CFG = node ? JSON.parse(node.textContent) : null;
  } catch (err) {
    return;
  }
  if (!CFG || !CFG.enabled || !CFG.variantId) return;

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var busy = false;
  var pending = null;
  var timer = null;
  var lastState = null;

  /* ---------------------------------------------------------------- para biçimi */

  /**
   * Mağazanın money_format'ını onurlandırır. Tek istisna: mağaza TRY iken format
   * İngilizce ayraç jetonunu kullanıyorsa (1,750.00) Türkçe kardeşine yükseltilir
   * (1.750,00). Aksi halde bu kampanya metni "Hediyenize 1,234.56TL kaldı" derdi.
   * Mağaza ayarı düzeltildiğinde burası kendiliğinden hizalanır.
   */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    var token = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    if ((CFG.currency === 'TRY') && token === 'amount') token = 'amount_with_comma_separator';
    if ((CFG.currency === 'TRY') && token === 'amount_no_decimals') token = 'amount_no_decimals_with_comma_separator';

    var value = (cents || 0) / 100;
    var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
    var comma = token.indexOf('comma_separator') !== -1;
    var locale = comma ? 'tr-TR' : 'en-US';
    var out;
    try {
      out = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    } catch (e) {
      out = value.toFixed(decimals);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /**
   * Cümle içinde kullanılacak ürün adı. Katalogdaki başlıklar "Ad | Nitelik"
   * biçiminde; tam başlık cümleye gömülünce "… Tek Saşe | Hediye siparişinize
   * hediye olarak eklendi" gibi okunuyor. Tema bu kırpmayı sepet önerilerinde
   * zaten yapıyor (`title | split: '|' | first | strip`) — aynı konvansiyon.
   */
  function urunAdi() {
    return String(CFG.productTitle || '').split('|')[0].trim();
  }

  function fill(tpl, remaining) {
    return String(tpl || '')
      .replace(/\{kalan\}/g, formatMoney(remaining))
      .replace(/\{esik\}/g, formatMoney(CFG.threshold))
      .replace(/\{urun\}/g, urunAdi());
  }

  /* ------------------------------------------------------------------- sepet ölçümü */

  function giftLines(cart) {
    return (cart.items || []).filter(function (i) { return i.variant_id === CFG.variantId; });
  }

  function eligibleTotal(cart) {
    var own = giftLines(cart).reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0);
    return Math.max(0, (cart.total_price || 0) - own);
  }

  /* --------------------------------------------------------------------- oturum izi */

  function seen(key) {
    try { return sessionStorage.getItem('sdx_gwp_' + key) === '1'; } catch (e) { return false; }
  }
  function mark(key) {
    try { sessionStorage.setItem('sdx_gwp_' + key, '1'); } catch (e) { /* özel sekme */ }
  }
  function unmark(key) {
    try { sessionStorage.removeItem('sdx_gwp_' + key); } catch (e) { /* özel sekme */ }
  }

  /* ------------------------------------------------------------------ uzlaştırma */

  /**
   * Hediye SdxCart.add ile DEĞİL, doğrudan /cart/add.js ile eklenir.
   *
   * Neden: SdxCart.add `cart:added` olayını yayar; temanın hızlı-ekle modalı
   * (sdx-quick-add-modal.js) bu olayı dinleyip "Sepete eklendi" bildirimini açar.
   * Hediye için bu yanlış — müşteri bir şey eklememiştir, kampanya eklemiştir;
   * üstelik o modal benim kazanıldı pop-up'ımın üstüne biner.
   * `SdxCart.get()` ile `cart:change` yine yayılır, yani sepet sayfası tazelenir.
   */
  function hediyeEkle() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: CFG.variantId,
        quantity: 1,
        properties: CFG.lineProperties
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('hediye eklenemedi: ' + res.status);
      return window.SdxCart.get();
    });
  }

  function reconcile(cart) {
    // Sepete ekleme/çıkarma işini indirim app'i (Kaching) üstlenmişse tema karışmaz —
    // iki taraf da eklerse hediye ÇİFT eklenir. Bu durumda tema yalnızca ölçer ve
    // pop-up/şerit gösterir. Panelden: "Hediyeyi tema sepete eklesin".
    if (!CFG.autoAdd) return Promise.resolve(cart);

    var lines = giftLines(cart);
    var total = eligibleTotal(cart);
    var qualified = CFG.available && total >= CFG.threshold;
    var qty = lines.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);

    // FAIL-SAFE — hediye satırı AZAMİ TUTARI aşarsa geri çek.
    //
    // Eşik sıfır değil, çünkü ERP bu SKU'yu 0,01 TL olarak tutmak zorunda (marka
    // kısıtı) ve fiyatı Shopify'a o yazıyor. Katı "> 0" kuralı kampanyayı her
    // seferinde öldürürdü — 2026-09-23'te tam bu oldu: tema hediyeyi ekledi,
    // guard 1 kuruşu "ücretli" sayıp geri çekti, şerit ise vaat etmeye devam etti.
    //
    // Koruma ayakta: fiyat gerçek değere (109,80) çekilirse eşik aşılır, satır geri
    // çekilir ve kampanya susar. Eşik panelden yönetilir ve Liquid tarafındaki
    // FİYAT KAPISI ile AYNI değerdir — vaat ile teslimat tek kapıdan geçsin diye.
    var azami = typeof CFG.maxGiftAmount === 'number' ? CFG.maxGiftAmount : 100;
    var ucretliHediye = lines.filter(function (i) { return (i.final_line_price || 0) > azami; });
    if (ucretliHediye.length) {
      CFG.available = false;
      return ucretliHediye
        .map(function (line) {
          return function (c) {
            return window.SdxCart.change(line.key, 0).catch(function () { return c; });
          };
        })
        .reduce(function (p, op) { return p.then(op); }, Promise.resolve(cart));
    }

    if (qualified && qty === 0) {
      return hediyeEkle().catch(function () {
        // Stok bitti / eklenemedi → bir daha vaat etme, bir daha deneme.
        CFG.available = false;
        return cart;
      });
    }

    if (qualified && (qty > 1 || lines.length > 1)) {
      // Tam 1 adede indir: ilkini 1'e sabitle, fazlalık satırları sil.
      var ops = lines.map(function (line, idx) {
        return function (c) {
          return window.SdxCart.change(line.key, idx === 0 ? 1 : 0).catch(function () { return c; });
        };
      });
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve(cart));
    }

    if (!qualified && lines.length) {
      var removals = lines.map(function (line) {
        return function (c) {
          return window.SdxCart.change(line.key, 0).catch(function () { return c; });
        };
      });
      return removals.reduce(function (p, op) { return p.then(op); }, Promise.resolve(cart));
    }

    return Promise.resolve(cart);
  }

  /* ------------------------------------------------------------ durum değerlendirme */

  function evaluate(cart) {
    var total = eligibleTotal(cart);
    var earned = giftLines(cart).length > 0 && total >= CFG.threshold;
    var remaining = Math.max(0, CFG.threshold - total);
    var state;

    if (earned) state = 'earned';
    else if (CFG.available && total >= CFG.teaserMin && total < CFG.threshold) state = 'teaser';
    else state = 'idle';

    // Sepet şeridinin tutarını pop-up ile AYNI biçimlendiriciden tazele.
    // (Şeridin ilk boyaması Liquid `| money` ile gelir; mağazanın para biçimi ayarı
    //  Türkçe değilse ikisi ayrışmasın diye burada eşitlenir.)
    var slots = document.querySelectorAll('[data-sdx-gwp-amount]');
    for (var s = 0; s < slots.length; s++) slots[s].textContent = formatMoney(remaining);

    document.dispatchEvent(new CustomEvent('sdx:gwp-state', {
      detail: { state: state, total: total, remaining: remaining, threshold: CFG.threshold }
    }));

    if (DESIGN_MODE) { lastState = state; return; }
    if (!CFG.siteWide && !document.querySelector('[data-sdx-cart-page]')) { lastState = state; return; }

    if (state === 'earned') {
      unmark('teaser');
      if (CFG.wonPopup && lastState !== 'earned' && !seen('won')) {
        mark('won');
        sirayaGir('won', remaining);
      }
    } else {
      unmark('won');
      if (state === 'teaser' && lastState !== 'teaser' && !seen('teaser')) {
        mark('teaser');
        sirayaGir('teaser', remaining);
      }
    }
    lastState = state;
  }

  /* -------------------------------------------------------------------- pop-up */

  var overlay = null;
  var lastFocus = null;

  /**
   * Aynı anda iki modal açılmaz. Müşteri ürünü sepete eklediğinde temanın
   * "Sepete eklendi" modalı açılır; eşik o eklemeyle aşıldıysa benim pop-up'ım
   * onun üstüne binerdi. Diğeri kapanana kadar sıraya girilir (en fazla ~16 sn).
   */
  function baskaModalAcik() {
    var qam = document.querySelector('.sdx-qam');
    return !!(qam && qam.classList.contains('is-open'));
  }

  function sirayaGir(kind, remaining, deneme) {
    deneme = deneme || 0;
    if (baskaModalAcik() && deneme < 40) {
      setTimeout(function () { sirayaGir(kind, remaining, deneme + 1); }, 400);
      return;
    }
    openPopup(kind, remaining);
  }

  function closePopup() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('sdx-gwp-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* koptu */ } }
    lastFocus = null;
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'sdx-gwp';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="sdx-gwp__scrim" data-sdx-gwp-close></div>' +
      '<div class="sdx-gwp__card" role="dialog" aria-modal="true" aria-labelledby="sdx-gwp-title" tabindex="-1">' +
        '<button type="button" class="sdx-gwp__close" data-sdx-gwp-close>' +
          '<span class="sdx-sr-only"></span>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="sdx-gwp__media"><img alt="" loading="lazy" width="150" height="150"></div>' +
        '<p class="sdx-gwp__badge"></p>' +
        '<h2 class="sdx-gwp__title" id="sdx-gwp-title"></h2>' +
        '<p class="sdx-gwp__body"></p>' +
        '<div class="sdx-gwp__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span></span></div>' +
        '<button type="button" class="sdx-btn sdx-btn--accent sdx-gwp__cta" data-sdx-gwp-close></button>' +
        '<p class="sdx-gwp__terms"></p>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-sdx-gwp-close]')) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) closePopup();
    });
  }

  function openPopup(kind, remaining) {
    if (!overlay) buildOverlay();
    var t = CFG.text || {};
    var won = kind === 'won';
    var img = overlay.querySelector('.sdx-gwp__media img');
    var src = (won ? CFG.productImage : (CFG.popupImage || CFG.productImage)) || '';

    if (src) { img.src = src; img.alt = CFG.productTitle || ''; overlay.querySelector('.sdx-gwp__media').removeAttribute('hidden'); }
    else { overlay.querySelector('.sdx-gwp__media').setAttribute('hidden', ''); }

    var badge = overlay.querySelector('.sdx-gwp__badge');
    badge.textContent = won ? (t.badge || '') : (t.value || '');
    badge.toggleAttribute('hidden', !badge.textContent);

    overlay.querySelector('.sdx-gwp__title').textContent = fill(won ? t.wonTitle : t.teaserTitle, remaining);
    overlay.querySelector('.sdx-gwp__body').textContent = fill(won ? t.wonBody : t.teaserBody, remaining);

    var bar = overlay.querySelector('.sdx-gwp__bar');
    var pct = won ? 100 : Math.max(0, Math.min(100, Math.round(((CFG.threshold - remaining) / CFG.threshold) * 100)));
    bar.setAttribute('aria-valuenow', String(pct));
    bar.firstElementChild.style.width = pct + '%';
    bar.classList.toggle('is-complete', won);

    var cta = overlay.querySelector('.sdx-gwp__cta');
    cta.textContent = won ? (t.wonCta || t.teaserCta || '') : (t.teaserCta || '');
    cta.toggleAttribute('hidden', !cta.textContent);

    var terms = overlay.querySelector('.sdx-gwp__terms');
    terms.textContent = t.terms || '';
    terms.toggleAttribute('hidden', !terms.textContent);

    overlay.querySelector('.sdx-gwp__close .sdx-sr-only').textContent = t.close || '';
    overlay.classList.toggle('sdx-gwp--won', won);

    lastFocus = document.activeElement;
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('sdx-gwp-open');
    requestAnimationFrame(function () {
      var card = overlay.querySelector('.sdx-gwp__card');
      if (card) card.focus();
    });
  }

  /* ---------------------------------------------------------------- olay döngüsü */

  function run(cart) {
    if (busy) { pending = cart; return; }
    busy = true;
    reconcile(cart)
      .then(function (next) { evaluate(next && next.items ? next : cart); })
      .catch(function () { /* sepet API'si düştü — kampanya sessizce beklemede */ })
      .then(function () {
        busy = false;
        if (pending) { var p = pending; pending = null; schedule(p); }
      });
  }

  function schedule(cart) {
    if (!cart || !window.SdxCart) return;
    clearTimeout(timer);
    timer = setTimeout(function () { run(cart); }, 80);
  }

  document.addEventListener('cart:change', function (e) { schedule(e.detail && e.detail.cart); });
  document.addEventListener('cart:added', function (e) { schedule(e.detail && e.detail.cart); });
})();
